import { AccentDivider as AccentDividerTypes } from '@/schemas/sceneDataSchema';
import { styled } from '@mui/material';

interface AccentDividerProps {
  component: AccentDividerTypes;
}

export const AccentDivider: React.FC<AccentDividerProps> = ({ component: { color } }) => {
  return <StyledDivider color={color} />;
};

interface StyledDividerProps {
  color?: AccentDividerTypes['color'];
}

const StyledDivider = styled('hr')<StyledDividerProps>`
  background-color: ${({ theme, color }) =>
    color && theme.palette[color] ? theme.palette[color].main : theme.palette.primary.main};
  width: 40px;
  height: 3px;
  border: none;
  margin: 0;
`;
